export default (clientHttp, apiVersion) => ({
  read() {
    return clientHttp.get(`${apiVersion}/user/contract_informations`)
  },
})
